import { render, staticRenderFns } from "./ListNavigationDrawer.vue?vue&type=template&id=2592e083"
import script from "./ListNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./ListNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DarkMode: require('/home/runner/work/loja/loja/components/DarkMode.vue').default})
